import request from '@/plugins/axios'

export function getDashboardData(userId) {
  return request({
    url: 'dashboard',
    method: 'get'
  })
}
